
        import 'TextBox.bdc1a83.css-module'
        export default {"TextBox":"TextBox_TextBox_bdc1a83"}
    